import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "dashboard";

@Injectable({
  providedIn: "root",
})
export class DashboardHandlerService {
  constructor(private apiService: ApiService) {}

  dashboardGet(masterAccountID: number, accountAppID: number) {
    return this.apiService.get(`${PATH}/${masterAccountID}/${accountAppID}`);
  }

  dashboardPut(
    masterAccountID: number,
    accountAppID: number,
    body: any,
    options?: any,
  ) {
    const id = body.id;
    return this.apiService.put(
      `${PATH}/${masterAccountID}/${accountAppID}/${id}`,
      body,
      options,
    );
  }

  dashboardPost(
    masterAccountID: number,
    accountAppID: number,
    body: any,
    options?: any,
  ) {
    return this.apiService.post(
      `${PATH}/${masterAccountID}/${accountAppID}`,
      body,
      options,
    );
  }

  deliveriesByCategoryGet(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/widgets/deliveries_by_category?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  installsGet(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/widgets/installs?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  mobileLocationAllowedGet(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/widgets/mobile_location_allowed?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  regionsSnapshotGet(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/widgets/regions_snapshot?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  onPropertyGet(masterAccountID: number, accountAppID: number) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/widgets/on_property`,
    );
  }

  deliveredContentGet(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/widgets/delivered_content?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  assistantThreadsGet(
    masterAccountID: number,
    accountAppID: number,
    integrationID: number,
    start: Date,
    end: Date,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/${integrationID}/widgets/assistant_threads?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  assistantDevicesUsersGet(
    masterAccountID: number,
    accountAppID: number,
    integrationID: number,
    start: Date,
    end: Date,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/${integrationID}/widgets/assistant_devices_users?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  assistantSharesRatingsFeedbackGet(
    masterAccountID: number,
    accountAppID: number,
    integrationID: number,
    start: Date,
    end: Date,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/${integrationID}/widgets/assistant_shares_ratings_feedback?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }
}
